import { useTimeGate } from '@exam-center/server-time';

import { ExamSessionCard, type ExamSessionCardProps } from '../../components/exam-session-card';

interface SessionCardItemProps extends Omit<ExamSessionCardProps, 'disabledProctoring'> {
  adjustedStarTime: Date;
}

export function SessionCardItem({ adjustedStarTime, ...cardProps }: SessionCardItemProps) {
  const hasStarted = useTimeGate(adjustedStarTime);
  return <ExamSessionCard disabledProctoring={!hasStarted} {...cardProps} />;
}
